export default __webpack_public_path__ + "static/media/bootstrap.css.bb2b4954.map";